namespace GeniuzPOS.PosShift {
    export namespace PosTranDtService {
        export const baseUrl = 'PosShift/PosTranDt';

        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PosTranDtRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PosTranDtRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ListByDocNo(request: ListByDocNoRequest, onSuccess?: (response: Serenity.ListResponse<PosTranDtRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Retrieve = "PosShift/PosTranDt/Retrieve",
            List = "PosShift/PosTranDt/List",
            ListByDocNo = "PosShift/PosTranDt/ListByDocNo"
        }

        [
            'Retrieve', 
            'List', 
            'ListByDocNo'
        ].forEach(x => {
            (<any>PosTranDtService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
